export default __webpack_public_path__ + "images/5F.62ece90.png";